import styled, { css } from "styled-components";

export const CSS = {
   CONTAINER: styled.article`
      padding: 40px 20px;
      background-color: rgb(37 99 246);
      ${props => !props.Media && css`
         padding: 80px 0px;
      `}
   `,
   TITLE: styled.div`
      display: flex; flex-direction: column;
      align-items: center;
      &>span {
         font-family: 'Poppins', sans-serif; font-weight: 500;
         font-size: 13px;
         padding: 0px 10px;
         color: rgb(29 0 114);
         background-color: rgb(255 255 255);
         ${props => !props.Media && css`
            font-size: 24px;
            padding: 0px 15px;
         `}
      }
      &>h1 {
         font-size: 20px;
         color: rgb(255 255 255);
         padding: 5px 0px;
         ${props => !props.Media && css`
            font-size: 40px;
            padding: 10px 0px;
         `}
      }
      &>a {
         font-family: 'Poppins', sans-serif;
         font-weight: 500;
         font-size: 15px;
         padding: 5px 15px;
         color: rgb(255 255 255);
         border-radius: 8px;
         background-color: rgb(28 33 93);
         ${props => !props.Media && css`
            font-size: 20px;
            padding: 10px 25px;
         `}
      }
   `,
   NAV: styled.div`
      display: flex; flex-wrap: wrap;
      justify-content: center;
      padding: 50px 0px 50px;
      button + button {
         margin-left: 10px;
         ${props => !props.Media && css`
            margin-left: 30px;
         `}
      }
      &>button {
         display: flex; flex-direction: column;
         align-items: center; justify-content: center;
         width: 80px; height: 80px;
         line-height: 1.05;
         font-size: 15px; font-weight: 800; color: rgb(37 99 246);
         border-radius: 8px; border: 2px solid rgb(245 179 165);
         margin-top: 10px;
         background-color: rgb(255 255 255);
         ${props => !props.Media && css`
            width: 160px; height: 160px;
            font-size: 32px;
            border: 4px solid rgb(245 179 165);
         `}
         &:hover {
            background-color: rgb(245 179 165);
         }
      }
   `,
   DISPLAY: styled.div`
      ${props => props.Width < 800 ? css`
         height: ${props.Width / 1.2}px;
      ` : css`
         height: 800px;
      `}
      &>div {
         display: flex; flex-direction: column;
         align-items: center; justify-content: space-around;
         height: 100%;
      }
      h1 {
         text-align: center;
         font-weight: 800; font-size: 13px; color: rgb(255 255 255);
         ${props => !props.Media && css`
            font-size: 21px;
         `}
      }
      .Img {
         display: flex; justify-content: center;
         width: 100%;
         img {
            width: 100%; max-width: 922px;
            object-fit: contain;
         }
      }
   `,
}